import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/folderOpen.svg';

import styles from './FolderOpenIcon.styles';

type FolderOpenIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'FolderOpenIcon' });

export default function FolderOpenIcon({ className }: FolderOpenIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
